import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { Grid, Typography, Collapse } from '@mui/material';

import AttendeeDashboardEventCard from '../events/AttendeeDashboardEventCard';

const getInviteEventId = (inv) => {
    if (!inv?.event) return null;
    if (typeof inv.event === 'object') {
        return inv.event._id ? String(inv.event._id) : null;
    }
    return String(inv.event);
};

const isCanceledInvite = (inv) =>
    Boolean(
        inv?.event &&
            typeof inv.event === 'object' &&
            inv.event.status === 'CANCELED'
    );

export { getInviteEventId, isCanceledInvite };

const CanceledAttendeeEvents = ({ invitedEvents }) => {
    const location = useLocation();
    const [showCanceledEvents, setShowCanceledEvents] = useState(false);
    const canceledInvites = (invitedEvents || [])
        .filter(isCanceledInvite)
        .sort((a, b) => {
            const aWhen =
                a?.event && typeof a.event === 'object'
                    ? a.event.bookingWhen
                    : null;
            const bWhen =
                b?.event && typeof b.event === 'object'
                    ? b.event.bookingWhen
                    : null;
            return (
                new Date(bWhen || 0).getTime() - new Date(aWhen || 0).getTime()
            );
        });

    useEffect(() => {
        if (canceledInvites.length > 0) {
            setShowCanceledEvents(true);
        }
    }, [canceledInvites.length]);

    useEffect(() => {
        const eventID = new URLSearchParams(location.search).get('eventID');
        if (!eventID || canceledInvites.length === 0) return;
        const targetsCanceled = canceledInvites.some(
            (inv) => String(getInviteEventId(inv)) === String(eventID)
        );
        if (targetsCanceled) {
            setShowCanceledEvents(true);
        }
    }, [location.search, invitedEvents]);

    if (canceledInvites.length === 0) {
        return null;
    }

    return (
        <>
            <Typography
                onClick={() => setShowCanceledEvents(!showCanceledEvents)}
                sx={{
                    color: 'var(--link-color)',
                    cursor: 'pointer',
                    margin: showCanceledEvents
                        ? '16px 16px 0px 16px'
                        : '16px 16px 16px 16px',
                    textAlign: 'center',
                }}
            >
                {showCanceledEvents
                    ? 'Hide Canceled Events'
                    : 'Show Canceled Events'}
            </Typography>
            <Collapse in={showCanceledEvents} timeout={300}>
                <Grid
                    container
                    direction="column"
                    sx={{
                        marginBottom: '20px',
                        marginTop: showCanceledEvents ? '0px' : '-20px',
                        transition: 'margin 0.3s ease-in-out',
                    }}
                >
                    <Grid item>
                        <Typography
                            component="h2"
                            sx={{ color: 'var(--red)!important' }}
                        >
                            {canceledInvites.length > 1
                                ? `These ${canceledInvites.length} concerts got canceled`
                                : `This concert got canceled`}
                            :
                        </Typography>
                    </Grid>
                    {canceledInvites.map(
                        (inv) =>
                            inv?.event && (
                                <AttendeeDashboardEventCard
                                    key={
                                        getInviteEventId(inv) +
                                        (inv.addedAt || '')
                                    }
                                    invite={inv}
                                />
                            )
                    )}
                </Grid>
            </Collapse>
        </>
    );
};

CanceledAttendeeEvents.propTypes = {
    invitedEvents: PropTypes.array,
};

const mapStateToProps = (state) => ({
    invitedEvents: Array.isArray(state.attendee?.me?.invitedEvents)
        ? state.attendee.me.invitedEvents
        : [],
});

export default connect(mapStateToProps, {})(CanceledAttendeeEvents);
